import { getDefaultFractionDigits } from '@scayle/storefront-nuxt'
import type { AppliedReduction, Price } from '@scayle/storefront-nuxt'
import { useCurrentShop } from '#storefront/composables'

type BaseOptions = {
  locale: string
  currencyFractionDigits?: number
}
type FormatOptions = BaseOptions
type ToCurrencyOptions = BaseOptions & {
  currency: string
}

export const toCurrency = (value: number, options?: ToCurrencyOptions) => {
  const currentShop = useCurrentShop()
  const {
    locale = currentShop.value.locale,
    currency = currentShop.value.currency,
    currencyFractionDigits = currentShop.value.currencyFractionDigits,
  } = options || {}

  // always use de-DE isoLocale so the formatting stays consistent throughout all country shops
  const isoLocale = locale === 'uk' ? 'en-GB' : 'de-DE'
  const minimumFractionDigits = getDefaultFractionDigits(isoLocale, currency)
  return (value / 100).toLocaleString(isoLocale, {
    style: 'currency',
    ...(currencyFractionDigits && {
      minimumFractionDigits: Math.min(
        minimumFractionDigits,
        currencyFractionDigits,
      ),
    }),
    maximumFractionDigits: currencyFractionDigits,
    currency,
  })
}

export const formatPrice = (value: number, formatOptions?: FormatOptions) => {
  const currentShop = useCurrentShop()
  const {
    locale = currentShop.value.locale,
    currencyFractionDigits = currentShop.value.currencyFractionDigits,
  } = formatOptions || {}
  return (value / 100).toLocaleString(locale, {
    minimumFractionDigits: currencyFractionDigits,
  })
}

// TODO: remove this function and use the one from storefront-core
// There are also instances where this was redefined locally in the same way
// e.g. in ProductPrice.vue
export const getTotalAppliedReductions = (
  price: Price,
  appliedReductions: AppliedReduction[],
) => {
  const total = { absoluteWithTax: 0, relative: 0.0 }
  if (price) {
    appliedReductions.forEach((reduction) => {
      total.absoluteWithTax += reduction.amount.absoluteWithTax
      total.relative += reduction.amount.relative
    })
  }
  return total
}
